/**
 * Normaliza un teléfono a formato E.164. Sin lada internacional se asume México (+52).
 * Devuelve null si no parece un número válido.
 */
export function normalizarTelefono(entrada: string): string | null {
  const conMas = entrada.trim().startsWith('+');
  let digitos = entrada.replace(/\D/g, '');
  if (!digitos) return null;

  if (!conMas && digitos.length === 10) return `+52${digitos}`;
  // Antiguo prefijo "1" de celulares mexicanos (+52 1 XX XXXX XXXX).
  if (digitos.length === 13 && digitos.startsWith('521')) digitos = `52${digitos.slice(3)}`;
  if (digitos.startsWith('52') && digitos.length === 12) return `+${digitos}`;
  if (conMas && digitos.length >= 10 && digitos.length <= 15) return `+${digitos}`;
  return null;
}

/** Formato legible: los números de México se muestran como `33 1234 5678`. */
export function formatearTelefono(e164: string): string {
  const mx = /^\+52(\d{2})(\d{4})(\d{4})$/.exec(e164);
  return mx ? `${mx[1]} ${mx[2]} ${mx[3]}` : e164;
}

/** Enlace de WhatsApp para un teléfono E.164. */
export function enlaceWhatsApp(e164: string): string {
  return `https://wa.me/${e164.replace(/\D/g, '')}`;
}
